import { ToDateTimeText, ToDateFullMonthText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import Alarm from '@material-ui/icons/Alarm';
import Link from '@material-ui/core/Link';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export const getColumns = (ViewHistory) => {
  const columns = [
    {
      dataField: "USER_ID",
      text: "User Name",
      sort: true,
      headerAlign: 'center',
      formatter: (cell, row) => {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              ViewHistory(row.USER_ID);
            }}
          >
            {row.USER_ID}
          </Link>
        )

      }
    },
    {
      dataField: "QUOTA_LIMIT",
      text: "Additional Quota",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      
    },
   
    {
      dataField: "ISACTIVE",
      text: "Status",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{row.ISACTIVE === 1 ? "Active" : "Inactive"}</>;
      },
    },
  ]
  return columns;
};
export const getHistoryColumns = (Download) => {
  const columns = [
    // {
    //   dataField: "TALEND_TASK_ID",
    //   text: "Task ID",
    //   sort: true,
    //   headerAlign: 'center',
    //   align: 'center',
    // },
    {
      dataField: "TALEND_REQUEST_ID",
      text: "Request ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TIME",
      text: "Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.SCHEDULE_TIME)}</>;
      },
    },
    {
      dataField: "DATE_TIME_START",
      text: "Start Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
      },
    },
    {
      dataField: "DATE_TIME_END",
      text: "End Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
      },
    },
    {
      dataField: "STATUS",
      text: "Status",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "EXECUTION_TIME",
      text: "Execution Time(Sec)",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DID",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            {(row.ISDOWNLOAD === "1") ? (

              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  Download(row.PATH_FILE);
                }}
              />

            ) : ""}
          </Box>
        );
      },
    },

  ];
  return columns;
};